
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-history",
      function () {
        return require("private-next-pages/our-history.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-history"])
      });
    }
  